<template>
  <div class="logout" role="status" aria-live="polite">
    <p>Signing you out&hellip;</p>
  </div>
</template>

<script>
/**
 * Ends the session.
 *
 * The route this replaces rendered the login form, because signing out was just
 * "drop the Vuex state and show the login page again" — which left any issued
 * token working until it expired. Logout is now RP-initiated against the
 * identity provider: it clears the local session, revokes the tokens
 * server-side, and ends the provider session too, so signing back in requires
 * the password and the second factor again.
 */
import oidc from '@/auth/oidcClient';
import { useSessionStore } from '@/stores/session';

export default {
  name: 'LogoutPage',

  async created() {
    try {
      useSessionStore().$reset();
    } catch (e) {
      /* the store may not be initialised; the provider logout still matters */
    }
    await oidc.logout();
  },
};
</script>

<style scoped>
.logout {
  min-height: 40vh;
  display: grid;
  place-items: center;
  color: #5c6e6d;
}
</style>
